"use strict";
exports.__esModule = true;
exports.Auth0Connection = void 0;
var Auth0Connection;
(function (Auth0Connection) {
    Auth0Connection["google"] = "google-oauth2";
    Auth0Connection["outlook"] = "guides-waad";
    Auth0Connection["slack"] = "slack";
})(Auth0Connection = exports.Auth0Connection || (exports.Auth0Connection = {}));
//# sourceMappingURL=auth-connection-enum.js.map